import "./OccupancyForecast.css";
import { InfoTooltip } from "./InfoTooltip";

export interface ForecastPeriod {
  periodNumber: number;
  periodLabel: string;
  inventory: number;
  occupancyPct: number;
  attritionPct: number;
  bookedDays: number;
  actualDays: number;
}

interface OccupancyForecastProps {
  fiscalYear: string;
  asOfDate?: string;
  tooltipText?: string;
  periods: ForecastPeriod[];
}

export function OccupancyForecast({
  fiscalYear,
  asOfDate,
  tooltipText,
  periods,
}: OccupancyForecastProps) {
  return (
    <div className="forecastWrap">
      <section className="forecastCard" aria-labelledby="forecast-heading">
        <h2 id="forecast-heading" className="forecastTitle">
          <span>DU Occupancy Forecast</span>
          {tooltipText && <InfoTooltip text={tooltipText} placement="bottom" renderInPortal />}
        </h2>

        <div className="tableWrap">
         
          <table className="table">
            <thead>
              <tr style={{ borderBottom: "1px solid #A7A8AA", height: "35px" }}>
                <th scope="col" style={{ width: "190px" }}>{fiscalYear}</th>
                {periods.map((p) => (
                  <th key={p.periodNumber} scope="col">
                    <span className="periodDate">{p.periodLabel}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="metricInventory" style={{ borderBottom: "1px solid #A7A8AA", height: "30px" }}>
                <th scope="row" >
                  Inventory
                </th>
                {periods.map((p) => (
                  <td key={p.periodNumber}>{p.inventory.toLocaleString()}</td>
                ))}
              </tr>
              <tr className="metricOccupancy" style={{ borderBottom: "1px solid #A7A8AA" , height: "35px"}}>
                <th scope="row">
                  Occupancy %
                  <span className="metricNote">Based on inventory</span>
                </th>
                {periods.map((p) => (
                  <td key={p.periodNumber}>{p.occupancyPct.toFixed(2)}%</td>
                ))}
              </tr>
              <tr className="metricAttrition" style={{ borderBottom: "1px solid #A7A8AA", height: "35px" }}>
                <th scope="row">
                  Attrition %
                  <span className="metricNote">Based on actuals</span>
                </th>
                {periods.map((p) => (
                  <td key={p.periodNumber}>{p.attritionPct.toFixed(2)}%</td>
                ))}
              </tr>
              <tr style={{ height: "35px"}}>
                <th scope="row">
                  Booked / actual days
                </th>
                {periods.map((p) => (
                  <td key={p.periodNumber}>
                    {p.bookedDays.toLocaleString()}
                     {/* /{" "}
                    {p.actualDays.toLocaleString()} */}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
